import { render, staticRenderFns } from "./FlyMenuItem.vue?vue&type=template&id=53e4adc8"
import script from "./FlyMenuItem.vue?vue&type=script&lang=js"
export * from "./FlyMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports